import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

export const avaliacaoApi = api
  .enhanceEndpoints({ addTagTypes: ["avaliacao"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      // ValorationStateEalth
      valorationStateEalth: builder.query({
        query: ({ id }: any) => ({
          url: `/evaluations/${id}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => response,
      }),

      valorationStateEalthHistory: builder.query({
        query: ({ id, table = "single_leg_squat_assessment" }: any) => ({
          url: `/evaluations/history/${id}?table=${table}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => response,
      }),

      //store
      storeValorationStateEalth: builder.mutation({
        query: ({ body }) => ({
          url: `/evaluations/store`,
          method: RequestMethod.POST,
          body: body,
        }),
        transformResponse: (response: any) => response,
      }),
    }),
  });
export const {
  useValorationStateEalthQuery,
  useValorationStateEalthHistoryQuery,
  useStoreValorationStateEalthMutation
} = avaliacaoApi;
